var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 54C43.2 54 54 43.2 54 30C54 16.8 43.2 6 30 6C16.8 6 6 16.8 6 30C6 43.2 16.8 54 30 54ZM30 0C46.5 0 60 13.5 60 30C60 46.5 46.5 60 30 60C13.5 60 0 46.5 0 30C0 13.5 13.5 0 30 0ZM43.0832 34.6351C44.1459 35.2255 44.5368 36.5603 43.9604 37.6306C43.3759 38.7161 42.0193 39.1181 40.9378 38.5263L30.1199 32.6071C28.1962 31.5546 27 29.5364 27 27.3436V17.25C27 16.0074 28.0074 15 29.25 15C30.4926 15 31.5 16.0074 31.5 17.25V24.6696C31.5 26.8486 32.6814 28.8563 34.5861 29.9145L43.0832 34.6351Z",
    fill: "#94A3EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.bb257ac922885a964f2cc0f92438a03a.svg";
export { ForwardRef as ReactComponent };